import Vue from 'vue'
import App from './Serp.vue'
import bp from 'babel-polyfill'

Vue.config.productionTip = false
new Vue({
  render: h => h(App)
}).$mount('#app')
